import { v1ApiClient } from '@/services';
import type { Operation, Schema } from '@/shared/api/generated';

type GetReportOperation = Operation<'GetReport'>;

export type GetReportParams = GetReportOperation['parameters']['path'];
export type GetReportResponse = Schema<'Report'>;

export const getReport = ({
  report_id,
}: GetReportParams): Promise<GetReportResponse> =>
  v1ApiClient.get(`/reports/${report_id}`).then((res) => res.data);
